import './header.scss';
import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin( CustomEase );

function initHeaderMenu() {
	if ( ! CustomEase.get( 'energy' ) ) {
		CustomEase.create( 'energy', 'M0,0 C0.32,0.72 0,1 1,1' );
	}

	const headerEl  = document.querySelector( '.p-header' );
	const toggleBtn = document.querySelector( '[data-menu-toggle]' );
	const menuEl    = document.querySelector( '[data-menu-panel]' );
	const overlayEl = document.querySelector( '[data-menu-overlay]' );
	const shellEls  = Array.from( document.querySelectorAll( '[data-shell]' ) );

	if ( ! toggleBtn || ! menuEl || ! overlayEl || ! shellEls.length ) {
		return;
	}

	const toggleLabels = toggleBtn.querySelectorAll( '.p-header__toggleLabel' );
	const iconMenu     = toggleBtn.querySelector( '.p-header__toggleSvg--menu' );
	const iconClose    = toggleBtn.querySelector( '.p-header__toggleSvg--close' );
	const largeItems   = menuEl.querySelectorAll( '[data-menu-reveal-large]' );
	const smallItems   = menuEl.querySelectorAll( '[data-menu-reveal-small]' );
	const darkEl         = overlayEl.querySelector( '.p-header__dark' );
	const corners        = overlayEl.querySelectorAll( '.p-header__corner' );
	const overlayBorders = overlayEl.querySelectorAll( '.p-header__borderRow' );

	// Kleur-targets worden NIET gecached — color-sets.js muteert --current-fg*
	// op body tijdens scroll, dus elke open/close moet de actuele computed
	// kleur opnieuw uitlezen. Zie functional values in de tweens hieronder.
	const getOpenColor   = () => getComputedStyle( menuEl ).color;
	const getClosedColor = () => getComputedStyle( headerEl ).color;

	let isOpen = false;
	let tl;
	let enterEndTime = 0;

	const getMenuOffset = () => -menuEl.offsetWidth;

	gsap.set( overlayEl, { visibility: 'hidden', pointerEvents: 'none' } );
	gsap.set( darkEl, { autoAlpha: 0 } );
	gsap.set( shellEls, { x: 0 } );
	gsap.set( toggleLabels, { yPercent: 0 } );
	gsap.set( iconMenu, { autoAlpha: 1, scale: 1, rotation: 0 } );
	gsap.set( iconClose, { autoAlpha: 0, scale: 0.6, rotation: -90 } );
	gsap.set( corners, { scale: 0 } );
	if ( overlayBorders[ 0 ] ) {
		gsap.set( overlayBorders[ 0 ], { yPercent: -100 } );
	}
	if ( overlayBorders[ 1 ] ) {
		gsap.set( overlayBorders[ 1 ], { yPercent: 100 } );
	}

	function buildTimeline() {
		tl = gsap.timeline( {
			paused: true,
			defaults: {
				ease: 'energy',
				easeReverse: 'power2.inOut',
			},
		} );

		tl.set( overlayEl, { visibility: 'visible', pointerEvents: 'auto' }, 0 );

		tl.to( [ ...shellEls, overlayEl ], {
			x: getMenuOffset,
			duration: 0.7,
		}, 0 )

		.to( darkEl, {
			autoAlpha: 1,
			'--p-header-dark-blur': '2px',
			duration: 0.5,
		}, 0 )

		.to( headerEl, {
			'--p-header-bar-blur': '0px',
			'--p-header-bar-bg-alpha': 0,
			duration: 0.4,
		}, 0 )

		.to( corners, {
			scale: 1,
			duration: 0.5,
		}, 0 )

		.to( overlayBorders, {
			yPercent: 0,
			duration: 0.5,
		}, 0 )

		.to( toggleLabels, {
			yPercent: -100,
			duration: 0.4,
		}, 0 )

		.to( toggleBtn, {
			color: getOpenColor,
			duration: 0.4,
		}, 0 )

		.to( iconMenu, {
			autoAlpha: 0,
			scale: 0.6,
			rotation: 90,
			duration: 0.3,
			ease: 'power2.in',
			easeReverse: 'power2.out',
		}, 0 )

		.to( iconClose, {
			autoAlpha: 1,
			scale: 1,
			rotation: 0,
			duration: 0.35,
			ease: 'back.out(1.4)',
			easeReverse: 'power2.in',
		}, 0.15 )

		.fromTo( largeItems,
			{ autoAlpha: 0, xPercent: 12 },
			{
				autoAlpha: 1,
				xPercent: 0,
				duration: 0.6,
				stagger: 0.05,
				ease: 'power3.out',
			},
			// Pas als de rand van de pagina de items bijna voorbij is: eerder
			// veegt die rand over items die al half zichtbaar zijn.
			0.15
		)

		.fromTo( smallItems,
			{ autoAlpha: 0, yPercent: 100 },
			{
				autoAlpha: 1,
				yPercent: 0,
				duration: 0.5,
				stagger: 0.03,
				ease: 'power3.out',
			},
			0.42
		);

		enterEndTime = tl.duration();

		tl.addPause();

		tl.to( [ largeItems, smallItems ], {
			autoAlpha: 0,
			duration: 0.3,
		}, '<' )

		.to( [ ...shellEls, overlayEl ], {
			x: 0,
			duration: 0.6,
		}, '<' )

		.to( darkEl, {
			autoAlpha: 0,
			'--p-header-dark-blur': '0px',
			duration: 0.35,
			ease: 'power2.inOut',
		}, '<' )

		.to( headerEl, {
			'--p-header-bar-blur': '5px',
			'--p-header-bar-bg-alpha': 0.36,
			duration: 0.3,
		}, '<' )

		.to( corners, {
			scale: 0,
			duration: 0.5,
		}, '<' )

		.to( overlayBorders[ 0 ], {
			yPercent: -100,
			duration: 0.5,
		}, '<' )

		.to( overlayBorders[ 1 ], {
			yPercent: 100,
			duration: 0.5,
		}, '<' )

		.to( toggleBtn, {
			color: getClosedColor,
			duration: 0.25,
		}, '<+=0.1' )

		.to( toggleLabels, {
			yPercent: 0,
			duration: 0.25,
			ease: 'power3.in',
		}, '<' )

		.to( iconClose, {
			autoAlpha: 0,
			scale: 0.6,
			rotation: -90,
			duration: 0.25,
			ease: 'power2.in',
		}, '<' )

		.to( iconMenu, {
			autoAlpha: 1,
			scale: 1,
			rotation: 0,
			duration: 0.3,
			ease: 'back.out(1.4)',
		}, '<+=0.1' )

		.set( overlayEl, {
			visibility: 'hidden',
			pointerEvents: 'none',
		} );
	}

	function toggle() {
		isOpen = ! isOpen;
		toggleBtn.setAttribute( 'aria-expanded', String( isOpen ) );
		toggleBtn.setAttribute( 'aria-label', isOpen ? 'Sluit menu' : 'Open menu' );
		document.body.setAttribute( 'data-menu-status', isOpen ? 'open' : '' );

		// Alleen invalidaten in rust: mid-animatie zouden de .to()-tweens hun
		// startwaarden op de halve stand her-opnemen, waardoor reverse() nooit
		// meer op de gesloten beginstand uitkomt (menu blijft half open hangen).
		// De functional color-values (getOpenColor/getClosedColor) worden zo
		// nog steeds bij elke open/close vanuit rust ververst — color-sets.js
		// muteert de --current-fg* vars immers alleen tijdens scroll.
		if ( ! tl.isActive() ) {
			if ( isOpen ) {
				// Dicht en in rust: nieuwe timeline in plaats van invalidate(). Die
				// zet de tijd van de tweens niet terug, dus bij een reverse() rendert
				// GSAP de sluit-tweens alsnog en nemen ze de halve stand als
				// beginwaarde. Het menu blijft dan half open hangen bij snel
				// open-dicht-open.
				tl.kill();
				buildTimeline();
			} else {
				tl.invalidate();
			}
		}

		if ( isOpen ) {
			if ( tl.time() > enterEndTime ) {
				// Exit loopt nog — speel terug naar het open-rustpunt (addPause).
				tl.timeScale( 1 ).reverse();
			} else {
				tl.timeScale( 1 ).play();
			}
		} else if ( tl.time() < enterEndTime ) {
			tl.timeScale( 1 ).reverse();
		} else {
			tl.timeScale( 1 ).play();
		}
	}

	buildTimeline();

	toggleBtn.addEventListener( 'click', toggle );

	overlayEl.addEventListener( 'click', () => {
		if ( isOpen ) {
			toggle();
		}
	} );

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && isOpen ) {
			toggle();
			toggleBtn.focus();
		}
	} );

	let resizeTimer;

	window.addEventListener( 'resize', () => {
		clearTimeout( resizeTimer );

		resizeTimer = setTimeout( () => {
			if ( isOpen ) {
				gsap.set( [ ...shellEls, overlayEl ], { x: getMenuOffset() } );
			} else if ( ! tl.isActive() ) {
				tl.invalidate();
			}
		}, 150 );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initHeaderMenu );
} else {
	initHeaderMenu();
}
